export default "__VITE_ASSET__ybYYWr7N__"